import React, { useEffect, useState } from 'react'
import { Text, View, Image, Dimensions, TouchableOpacity } from 'react-native'
import * as Progress from 'react-native-progress'
import styles from './MyAdvanceStyles'
import theme from '../../../theme'
import { avatarPlaceholder } from '../customUtils/Constants'
import { colorFilled, colorUnfilled } from '../../../themeConstants'
import { ScrollView } from 'react-native-gesture-handler'
import { FlashList } from '@shopify/flash-list'
import { AdvanceTeamModel, AdvanceTeamRegion, MyAdvanceModel, MyAdvanceSingleModel } from './models/MyAdvanceModel'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { MyAdvanceScreen } from './MyAdvance'
import { Loader } from '../customUtils/Components/Loader'
import { fetchAuthSession } from 'aws-amplify/auth'
import { getConection } from '../appBar/context/HeaderContext'
import { request_get_advanced } from '../../services/advance.services'
import { DateFormatter } from '../customUtils/DateFormatter'

const { width } = Dimensions.get('window')

export const MyTeamScreen = ({ route }) => {
    const id = route?.params?.id
    const [myAdvance, setMyAdvance] = useState(null)
    const [updateDate, setUpdateDate] = useState('')
    const { isConnected, hasInternet } = getConection()
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        // setMyAdvance(TeamData)
        try {
            if (isConnected && hasInternet) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                const data: MyAdvanceSingleModel = await request_get_advanced({ authToken, id })

                if (!data) {
                    return
                }
                if (data.my_advance) {
                    setMyAdvance(data.my_advance)
                }

                //@Fixme validar si la fecha es invalida
                let date = DateFormatter({ date: data.date })
                setUpdateDate(date)
            }
        } catch (e) {
            console.log('Error al obtener la informacion', e)
        } finally {
            setLoading(false)
        }
    }
    if (loading) {
        return <Loader />
    }
    if (!myAdvance) {
        return (
            <View>
                <View style={styles.spacer2}></View>
                <Image source={require('../../../assets/advance/noDataEvaluations.png')} style={styles.noDataEvaluations} />
                <View style={styles.spacer1}></View>
                <View style={styles.spacer1}></View>
                <Text style={styles.noDataText}>No hay información</Text>
                <View style={styles.spacer2}></View>
            </View>
        )
    }
    return <MyAdvanceScreen myAdvance={myAdvance} updateDate={updateDate} />
}

const TeamData: MyAdvanceModel = {
    name: 'John Doe',
    avatar: 'https://example.com/avatar.jpg',
    level: '5',
    watched_content: {
        total: 120.5,
        detail: [
            {
                name: 'Course 1',
                total: 50.0,
            },
            {
                name: 'Course 2',
                total: 70.5,
            },
        ],
        indice_salesbook: 85.0,
    },
    my_achievements: [
        {
            name: 'Achievement 1',
            description: 'Completed the course',
            image: 'https://example.com/achievement1.jpg',
            download_url:
                'https://cdn-ghkoj.nitrocdn.com/kjYfdEBKRwdYwvHQyjaYBdTGFpFGjqYW/assets/images/optimized/rev-39d8e95/sertifier.com/blog/wp-content/uploads/2020/10/certificate-text-samples.jpg',
        },
        {
            name: 'Achievement 2',
            description: 'Top scorer',
            image: 'https://example.com/achievement2.jpg',
            download_url: 'https://example.com/achievement2-download',
        },
    ],
    my_exams: [
        {
            name: 'Exam 1',
            score: 90.0,
            download_url:
                'https://cdn-ghkoj.nitrocdn.com/kjYfdEBKRwdYwvHQyjaYBdTGFpFGjqYW/assets/images/optimized/rev-39d8e95/sertifier.com/blog/wp-content/uploads/2020/10/certificate-text-samples.jpg',
            approved: true,
            attempts: 2,
        },
    ],
    my_points: {
        level: 'Advanced',
        ranking: 2.0,
        points: 1500.0,
    },
    role: 'Student',
}
